(function ($, Drupal) {

  // Mobile main menu on Shop page.
  Drupal.behaviors.toggleNavigation = {
    attach: function (context, settings) {

      $('.shop__navigation', context).once('toggleNavigation').each(function () {

        let $el = $(this),
          $toggler = $el.find('.shop__switch'),
          $menu = $el.find('.menu'),
          $resPixel = $('.js_resolution');

        if ($resPixel.css('opacity') < '0.5') {
          $toggler.click(function() {
            $menu.toggleClass('is_active');
          });
        }

      });

    }
  };

})(jQuery, Drupal);
